import { ReactNode } from "react";
import Image from "next/image";

import { Text } from "@aprosoja/ui";

import successCheck from "@/public/sign-up/success-check.png";
import redAlertTriangle from "@/public/sign-up/red-alert-triangle.png";
import Summary from "./summary";

type ContentWrapperProps = {
  children: ReactNode;
  title: string;
  description?: string;
  hasSummary?: boolean;
  isAfterPayment?: boolean;
  paymentSucceeded?: boolean;
};

const ContentWrapper = ({
  children,
  title,
  description,
  hasSummary,
  isAfterPayment,
  paymentSucceeded,
}: ContentWrapperProps) => {
  return (
    <div className="flex flex-col w-full gap-size-x8 tabletLarge:flex-row">
      <div className="flex flex-col w-full gap-size-x8">
        {isAfterPayment && (
          <Image
            src={paymentSucceeded ? successCheck : redAlertTriangle}
            alt="Estado do pagamento"
            height={88}
            width={88}
          />
        )}
        <Text type="headingL">{title}</Text>
        {description && <Text type="paragraphL">{description}</Text>}
        <div className="flex flex-col w-full gap-size-x6">{children}</div>
      </div>
      {hasSummary && <Summary />}
    </div>
  );
};

export default ContentWrapper;
